export function getScaleFromCSS(element) {
	const style = window.getComputedStyle(element);

	// Modern browsers
	if (style.scale && style.scale !== 'none') {
		// Returns something like: "1.5 1.5"
		const values = style.scale.split(' ');
		return parseFloat(values[0]);
	}

	// Fallback (older browsers)
	const transform = style.transform;
	if (transform && transform !== 'none') {
		const matrix = transform.match(/matrix\(([^)]+)\)/);
		if (matrix) {
			const values = matrix[1].split(',');
			return parseFloat(values[0]);
		}
	}

	return 1;
}

export function haversineDistance(lat1, lng1, lat2, lng2) {
	const R = 6371; // Earth's radius in km
	const toRad = (deg) => (deg * Math.PI) / 180;

	const dLat = toRad(lat2 - lat1);
	const dLng = toRad(lng2 - lng1);

	const a =
		Math.sin(dLat / 2) ** 2 +
		Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;

	return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
